<footer class="dekra-footer">
  <a class="dekra-margin-right" href="https://www.dekra.de/de/impressum/"
     [target]="Target.BLANK">{{ 'BUI.FOOTER.IMPRINT'|translate }}</a>
  <a class="dekra-margin-right" href="https://www.dekra.de/de/agb/"
     [target]="Target.BLANK">{{ 'BUI.FOOTER.TERMS'|translate }}</a>
  <a href="https://www.dekra.de/de/datenschutz/" [target]="Target.BLANK">{{ 'BUI.FOOTER.PRIVACY'|translate }}</a>
</footer>
